<template>
  <div>
    <div v-if="loading">
      <div class="text-center">
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
        <b-spinner
          small
          variant="primary"
          type="grow"
          label="Spinning"/>
      </div>
    </div>
    <div v-else>
      <div
        v-if="(modules == null && preset != null && preset.length === 0)
        || (preset == null && modules != null && modules.length === 0)">
        <b-row class="align-center text-center">
          <b-col><i>Aucune liste de modules</i></b-col>
        </b-row>
      </div>
      <div v-else>
        <b-row v-if="type === 'activities'">
          <b-col>
            <b-form-group
              label="Filtrer"
              label-cols-sm="3"
              label-align-sm="left"
              label-size="sm"
              label-for="filterInput">
              <b-input-group size="sm">
                <b-form-input
                  id="filterInput"
                  v-model="filter"
                  type="search"
                  placeholder="Taper pour rechercher un module"/>
                <b-input-group-append>
                  <b-button
                    :disabled="!filter"
                    @click="filter = ''">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-table
          :fields="fields"
          :items="getFilteredModules()"
          :filter="filter"
          :filter-included-fields="filterOn"
          :key="reRender"
          small
          responsive="sm">
          <template #cell(order)="row"
            v-if="type === 'root'"
            >
            <b-col>{{ row.item.show_order ? row.item.show_order : '' }}</b-col>
          </template>
          <template #cell(modu_name)="row">
            <b-col>{{ row.item.modu_name }}</b-col>
          </template>
          <template #cell(is_enabled)="row">
            <b-col>
              <b-badge :variant="row.item.is_enabled ? 'success' : 'danger'">
                {{ row.item.is_enabled ? 'Actif' : 'Inactif' }}
              </b-badge>
            </b-col>
          </template>
          <template #cell(overrided)="row">
            <b-col>
              <b-badge :variant="row.item.overrided ? 'success' : 'warning'">
                {{ row.item.overrided ? 'Surchargé' : 'Défaut' }}
              </b-badge>
            </b-col>
          </template>
          <template #cell(tmo_data)="row">
            <div class="preview-item">
              <!-- TODO : Si module abstrait + tous les modules désactivés sauf un, module restant en paramètre -->
              <module-preview
                :module="row.item"
                :theme="establishment.theme"
                :order="row.index"
                :length="modules.filter(e => e.modu_act_id === null && e.modu_is_root).length"
                :key="reRender"/>
            </div>
          </template>
          <template #cell(pmo_data)="row">
            <b-col v-if="row.item.pmo_data && row.item.pmo_data.ids">
              <b-button
                :key="reRender"
                variant="outline-primary"
                @click="onToggleAbstract(row)">Modules abstraits</b-button>
            </b-col>
            <b-col v-else>
              {{ getParamsType(row.item) }}
              <br >
              {{ getParamsInfos(row.item) }}
            </b-col>
          </template>
          <template #row-details="row">
            <b-card>
              <list-modules
                :establishment="establishment"
                :preset="row.item"
                :key="reRender"
                :is-abstract="true"
                type="root"/>
            </b-card>
          </template>
          <template #cell(update)="row">
            <b-container>
              <b-row
                v-if="type !== 'invisible'"
                class="p-md-2">
                <b-button
                  v-b-modal="'modal-update-status-'+ row.item.modu_id"
                  :variant="row.item.is_enabled ? 'danger' : 'success'"
                  block
                  @click="changeType = 'status'">
                  {{ row.item.is_enabled ? 'Désactiver' : 'Activer' }}
                </b-button>
              </b-row>
              <b-row
                v-if="type === 'root'"
                class="p-md-2">
                <b-button
                  v-b-modal="'modal-update-module-'+ row.item.modu_id"
                  block
                  variant="primary"
                  @click="changeType = 'update'">
                  Modifier
                </b-button>
              </b-row>
              <b-row
                v-if="row.item.overrided"
                class="p-md-2">
                <b-button
                  v-b-modal="'modal-update-status-'+ row.item.modu_id"
                  block
                  variant="warning"
                  @click="changeType = 'reset'">
                  Rétablir paramètres d'origine
                </b-button>
              </b-row>
              <b-row class="p-md-2">
                <b-button
                  v-b-modal="'modal-troubleshoot-'+ row.item.modu_id"
                  block
                  variant="outline-warning"
                  @click="changeType = 'update'">
                  Dépanner
                </b-button>
              </b-row>
              <b-modal
                :id="'modal-update-module-'+ row.item.modu_id"
                title="Modifier un module"
                scrollable
                hide-footer>
                <form-module-setting
                  :module="row.item"
                  @sendForm="receiveUpdate"/>
              </b-modal>
              <modal-troubleshoot
                :esta_id="establishment.esta_id"
                :full="false"
                :target="'modal-troubleshoot-'+ row.item.modu_id"
                :id="row.item.modu_id"
                :devices="devices"
                :label="row.item.modu_name"
                type="modu"/>
            </b-container>
            <b-modal
              :id="'modal-update-status-'+ row.item.modu_id"
              :title="defineModaleTitle(row.item)"
              size="lg"
              scrollable
              hide-footer>
              <b-container>
                <b-row
                  class="align-center text-center"
                  align-v="center"
                  align-content="center">
                  <b-col
                    class="p-md-3"
                    size="lg">Appliquer la modification...</b-col>
                </b-row>
                <b-row
                  v-if="establishment.parent"
                  class="align-center text-center"
                  align-v="center"
                  align-content="center">
                  <b-col
                    class="p-md-3 text-center align-center"
                    align-content="center">
                    <b-button
                      size="lg"
                      block
                      variant="success"
                      class="m-auto"
                      @click="changeModuleStatus(establishment.esta_id, null, !row.item.is_enabled, row.item.modu_id)">
                      Pour cet établissement
                    </b-button>
                  </b-col>
                  <b-col
                    class="p-md-3 text-center align-center"
                    align-content="center">
                    <b-button
                      size="lg"
                      block
                      variant="warning"
                      class="m-auto"
                      @click="changeModuleStatus(null, establishment.cont_id, !row.item.is_enabled, row.item.modu_id)">
                      Pour tous les établissements du groupement
                    </b-button>
                  </b-col>
                </b-row>
                <b-row
                  v-else
                  class="align-center text-center"
                  align-v="center"
                  align-content="center">
                  <b-col
                    class="p-md-3 text-center align-center"
                    align-content="center">
                    <b-button
                      size="lg"
                      block
                      variant="success"
                      class="m-auto"
                      @click="changeModuleStatus(establishment.esta_id, null, !row.item.is_enabled, row.item.modu_id)">
                      Oui
                    </b-button>
                  </b-col>
                  <b-col
                    class="p-md-3 text-center align-center"
                    align-content="center">
                    <b-button
                      size="lg"
                      block
                      variant="warning"
                      class="m-auto"
                      @click="$bvModal.hide('modal-update-status-'+ row.item.modu_id)">
                      Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </b-container>
            </b-modal>
          </template>
        </b-table>

      </div>
    </div>
  </div>
</template>

<script>

import FormModuleSetting from '../forms/FormModuleSetting.vue';
import ModulePreview from '../ModulePreview.vue';
import ModalTroubleshoot from '../ModalTroubleshoot.vue';

export default {
  name: 'ListModules',
  components: { ModalTroubleshoot, ModulePreview, FormModuleSetting },
  props: {
    establishment: {
      type: Object,
      default: null,
    },
    preset: {
      type: Array,
      default: null,
    },
    type: {
      type: String,
      default: null,
    },
    devices: {
      type: Array,
      default: null,
    },
    isAbstract: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: 'List Modules',
      fields: [
      ],
      filter: null,
      filterOn: [],
      loading: true,
      modules: [],
      reRender: 0,
      changeType: null,
      formUpdate: null,
      moduleToUpdate: null,
    };
  },
  mounted() {
    this.callModules();
    if (this.type === 'root') {
      this.fields = [{
        order: {
          label: 'Ordre',
          tdClass: 'align-middle',
        },
      },
      {
        modu_name: {
          label: 'Nom',
          tdClass: 'align-middle',
        },
      },
      {
        is_enabled: {
          label: 'Actif',
          tdClass: 'align-middle',
        },
      },
      {
        overrided: {
          label: 'Surchargé',
          tdClass: 'align-middle',
        },
      },
      {
        tmo_data: {
          label: 'Preview',
          tdClass: 'align-middle',
        },
      },
      {
        pmo_data: {
          label: 'Paramètres infos',
          tdClass: 'align-middle',
        },
      },
      {
        update: {
          label: 'Actions',
          tdClass: 'align-middle',
        },
      }];
    } else if (this.type === 'activities') {
      this.fields = [
        {
          modu_name: {
            label: 'Nom',
            tdClass: 'align-middle',
          },
        },
        {
          is_enabled: {
            label: 'Actif',
            tdClass: 'align-middle',
          },
        },
        {
          overrided: {
            label: 'Surchargé',
            tdClass: 'align-middle',
          },
        },
        {
          tmo_data: {
            label: 'Preview',
            tdClass: 'align-middle',
          },
        },
        {
          pmo_data: {
            label: 'Paramètres infos',
            tdClass: 'align-middle',
          },
        },
        {
          update: {
            label: 'Actions',
            tdClass: 'align-middle',
          },
        }];
    } else if (this.type === 'invisible') {
      this.fields = [
        {
          modu_name: {
            label: 'Nom',
            tdClass: 'align-middle',
          },
        },
        {
          is_enabled: {
            label: 'Actif',
            tdClass: 'align-middle',
          },
        },
        {
          overrided: {
            label: 'Surchargé',
            tdClass: 'align-middle',
          },
        },
        {
          pmo_data: {
            label: 'Paramètres infos',
            tdClass: 'align-middle',
          },
        },
        {
          update: {
            label: 'Actions',
            tdClass: 'align-middle',
          },
        }];
    }
  },
  methods: {
    loadModules(modules) {
      this.loading = false;
      this.modules = modules;
      this.reRender += 1;
    },
    callModules() {
      this.$store.dispatch('establishments/getSettingsModule',
        { esta_id: this.establishment.esta_id })
        .then(response => this.loadModules(JSON.parse(JSON.stringify(response.data))));
    },
    defineModaleTitle(module) {
      if (this.changeType === 'status') {
        return module.is_enabled ? 'Désactiver un module' : 'Activer un module';
      }
      if (this.changeType === 'reset') {
        return 'Rétablir les paramètres d\'origine';
      }
      if (this.changeType === 'update') {
        return 'Changer les informations';
      }
      return '';
    },
    onToggleAbstract(currentRow) {
      currentRow.toggleDetails();
    },
    getPreset(abstractModule) {
      return this.modules.filter(e => abstractModule.pmo_data.ids.includes(e.modu_id));
    },
    getFilteredModules() {
      if (this.preset) {
        return this.getPreset(this.preset);
      }
      if (this.type === 'root') {
        return this.modules.filter(e => e.modu_act_id === null
          && e.modu_is_root
          && (!e.pmo_data || !e.pmo_data.is_abstract))
          .sort((a, b) => ((b.show_order === null) ? -1 : (a.show_order - b.show_order)));
      } if (this.type === 'invisible') {
        return this.modules.filter(e => e.modu_act_id === null && !e.modu_is_root)
          .sort((a, b) => ((b.modu_name === null) ? -1 : (a.modu_name - b.modu_name)));
      } if (this.type === 'activities') {
        return this.modules.filter(e => e.modu_act_id !== null)
          .sort((a, b) => {
            if (a.modu_name < b.modu_name) { return -1; }
            if (a.modu_name > b.modu_name) { return 1; }
            return 0;
          });
      }
      return [];
    },
    getParamsType(module) {
      if (module.pmo_data) {
        if (module.pmo_data.uri && module.pmo_data.type && module.pmo_data.type === 'web') {
          return 'Site web: ';
        }
        if (module.pmo_data.uri) {
          return 'Application: ';
        }
        if (module.pmo_data.action) {
          return 'Action: ';
        }
      }
      return 'Module ANISEN';
    },
    getParamsInfos(module) {
      if (module.pmo_data) {
        if (module.pmo_data.uri) {
          return module.pmo_data.uri;
        }
        if (module.pmo_data.action) {
          return module.pmo_data.action;
        }
      }
      return '';
    },
    receiveUpdate(formModule, oldModule) {
      const form = JSON.parse(formModule);
      const moduId = form.modu_id;
      this.$root.$emit('bv::hide::modal', `modal-update-module-${moduId}`);
      this.$root.$emit('bv::show::modal', `modal-update-status-${moduId}`);
      // const staf_id = JSON.parse(formStaff).staf_id;
      // this.$root.$emit('bv::hide::modal', `modal-update-staff-${staf_id}`);
      this.formUpdate = form;
      this.moduleToUpdate = oldModule;
    },
    changeModuleStatus(estaId, estaParentId, status, moduId) {
      if (this.changeType === 'status') {
        this.$store.dispatch('establishments/setModuleStatus',
          {
            esta_id: estaId,
            esta_relativeto_id: estaParentId,
            is_enabled: status,
            modu_id: moduId,
          })
          .then(() => this.callModules());
      }
      if (this.changeType === 'reset') {
        this.$store.dispatch('establishments/resetModuleSettings',
          {
            esta_id: estaId,
            esta_relativeto_id: estaParentId,
            modu_id: moduId,
          })
          .then(() => this.callModules());
      }
      if (this.changeType === 'update') {
        this.formUpdate.esta_id = estaId;
        this.formUpdate.esta_relativeto_id = estaParentId;
        this.formUpdate.order = parseInt(this.formUpdate.order, 10)
        if (this.moduleToUpdate.show_order !== this.formUpdate.order) {
          this.$store.dispatch('modules/updateModuleOrder', this.formUpdate).then(() => this.callModules());
        }
        if (this.moduleToUpdate.tmo_data
            && this.moduleToUpdate.tmo_data.name
            && this.moduleToUpdate.tmo_data.name !== this.formUpdate.theme_name) {
          this.$store.dispatch('modules/addModuleName', this.formUpdate).then(() => this.callModules());
        }
        if (this.moduleToUpdate.pmo_data
            && this.moduleToUpdate.pmo_data.uri
            && this.moduleToUpdate.pmo_data.type
            && this.moduleToUpdate.pmo_data.type === 'web'
            && this.moduleToUpdate.pmo_data.uri !== this.formUpdate.params_uri) {
          if (this.isAbstract) {
            this.formUpdate.is_abstract = true;
          }
          this.$store.dispatch('modules/addModuleParams', this.formUpdate).then(() => this.callModules());
        }
      }
      this.$bvModal.hide(`modal-update-status-${moduId}`);
    },
  },
};
/* TODO : - Changement de params : Faire une liste de paramètres possibles
  *  TODO : - Changement de nom : on insère si le thème n'existe pas
  * */
</script>
<style>
.preview-item{
  background: aliceblue;
  padding: 3px;
}
</style>
